import { FontSizes, IIconStyles, IMessageBarStyles, ITheme } from '@fluentui/react';
import { CSSProperties } from 'react';
import { IContactUsTheme } from '../../web-legacy/packages/contactUs/styles/theme.model';

export const getNotificationMessageBarStyles = (theme: ITheme, useExtendPalette: boolean): IMessageBarStyles => {
  let backgroundColor = theme.semanticColors.bodyBackgroundChecked;
  let textColor = theme.semanticColors.bodyText;
  // eslint-disable-next-line security/detect-non-literal-fs-filename
  let linkColor = theme.semanticColors.link;
  if (useExtendPalette) {
    backgroundColor = (theme as IContactUsTheme).extensionPalettes.notificationBackground;
    textColor = (theme as IContactUsTheme).extensionPalettes.black;
    linkColor = (theme as IContactUsTheme).extensionPalettes.lightBlueLink;
  }
  return {
    root: {
      backgroundColor: backgroundColor,
      borderRadius: '4px',
      marginTop: '20px',
    },
    iconContainer: {
      margin: '1em 0px 8px 16px',
    },
    icon: {
      color: '#005FB7',
      fontSize: '17px',
    },
    text: {
      fontFamily: "'Segoe UI', 'Open Sans', Roboto, 'Helvetica Neue', sans-serif",
      fontSize: FontSizes.medium,
      color: textColor,
      margin: '1em 0px 1em 14px',
      selectors: {
        a: {
          textDecoration: 'none',
          color: `${linkColor} !important`,
        },
        p: {
          margin: '0px',
        },
      },
    },
    innerText: {
      width: '100%', // For IE 11 https://stackoverflow.com/questions/35111090/text-in-a-flex-container-doesnt-wrap-in-ie11
    },
    dismissal: {
      margin: '8px 4px 0px 0px',
    },
  };
};

export const getNotificationDismissIconStyles = (theme: ITheme, useExtendPalette: boolean): IIconStyles =>
  useExtendPalette
    ? {
        root: {
          color: `${(theme as IContactUsTheme).extensionPalettes.black} !important`,
        },
      }
    : {}; // No need to override default color if the theme is defined correctly.

export const NotificationDivStyle: CSSProperties = { lineHeight: '20px' };
